import { render, staticRenderFns } from "./UpdateSampleInfoModal.vue?vue&type=template&id=3c9874ee&scoped=true&"
import script from "./UpdateSampleInfoModal.vue?vue&type=script&lang=js&"
export * from "./UpdateSampleInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9874ee",
  null
  
)

export default component.exports